module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1036.10692af9.png";